import {
    SET_ORDER,
    SET_ENABLEORDERTRACKING,
    SET_ENABLEDROPSHIPFLAG,
    SET_SHOWRETURNABLE,
    SET_ENABLEPARTORDERING
} from './types';


const initialState = {
    selectedOrder: '',
    enableOrderTracking: false,
    enableDropshipFlag:false,
    showReturnableFlag: false,
    enablePartOrdering: false
};

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ORDER: {
            return {
                ...state, ...action.selectedOrder
            };
        }
        case SET_ENABLEORDERTRACKING: {
            return {
                ...state, ...action.enableOrderTracking
            };
        }
        case SET_ENABLEDROPSHIPFLAG: {
            return {
                ...state, ...action.enableDropshipFlag
            };
        }
        case SET_SHOWRETURNABLE: {
            return {
                ...state, ...action.showReturnableFlag
            };
        }
        case SET_ENABLEPARTORDERING: {
            return {
                ...state, ...action.enablePartOrdering
            };
        }
        default:
            return state;
    }    
}


export default reducers;
